// // import React, { useEffect, useState } from "react";
// // import { Select, Spin } from "antd";
// // import DynamicBarChart from "./barChart";
// // import DynamicLineChart from "./lineChart";
// // import DynamicPieChart from "./pieChart";

// // const { Option } = Select;

// // const ExpenseChart = ({ apiUrl, chartTitle }) => {
// //   const [chartType, setChartType] = useState("bar");
// //   const [data, setData] = useState([]);
// //   const [loading, setLoading] = useState(true);

// //   // Fetch dynamic data from API
// //   useEffect(() => {
// //     const fetchData = async () => {
// //       try {
// //         const res = await fetch(apiUrl);
// //         const result = await res.json();
// //         setData(result);
// //       } catch (err) {
// //         console.error("Error fetching chart data:", err);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     fetchData();
// //   }, [apiUrl]);

// //   const handleChartChange = (value) => setChartType(value);

// //   return (
// //     <div className="p-4 bg-white rounded-2xl shadow-md">
// //       <div className="flex justify-between items-center mb-4">
// //         <h2 className="text-lg font-semibold">{chartTitle}</h2>
// //         <Select value={chartType} style={{ width: 120 }} onChange={handleChartChange}>
// //           <Option value="bar">Bar</Option>
// //           <Option value="line">Line</Option>
// //           <Option value="pie">Pie</Option>
// //         </Select>
// //       </div>

// //       {loading ? (
// //         <div className="flex justify-center"><Spin /></div>
// //       ) : (
// //         <>
// //           {chartType === "bar" && (
// //             <DynamicBarChart
// //               data={data}
// //               xField="productTypeName"
// //               yField="Amount"
// //               title={chartTitle}
// //             />
// //           )}
// //           {chartType === "line" && (
// //             <DynamicLineChart
// //               data={data}
// //               xField="productTypeName"
// //               yField="Amount"
// //               seriesField="productTypeName"
// //               title={chartTitle}
// //             />
// //           )}
// //           {chartType === "pie" && (
// //             <DynamicPieChart
// //               data={data}
// //               angleField="Amount"
// //               colorField="productTypeName"
// //               title={chartTitle}
// //             />
// //           )}
// //         </>
// //       )}
// //     </div>
// //   );
// // };

// // export default ExpenseChart;

// import React, { useState } from "react";
// import { Select, Spin } from "antd";
// import DynamicBarChart from "./barChart";
// import DynamicColumnChart from "./columnChart";
// import DynamicLineChart from "./lineChart";
// import DynamicPieChart from "./pieChart";

// const { Option } = Select;

// const AreaCovered = ({
//   data = [],
//   chartTitle = "",
//   xField = "",
//   yField = "",
//   xAxisTitle = "",
//   yAxisTitle = "",
//   loading = false,
// }) => {
//   const [chartType, setChartType] = useState("column");

//   const handleChartChange = (value) => setChartType(value);

//   return (
//     <div className=" bg-white rounded-2xl shadow-md">
//       <div className="flex justify-between items-center mb-4">
//         {/* <h4 className="text-lg font-semibold text-center">{chartTitle}</h4> */}
//         <Select
//           value={chartType}
//           style={{ width: 120 }}
//           onChange={handleChartChange}
//         >
//           <Option value="column">Column</Option>
//           <Option value="bar">Bar</Option>
//           <Option value="line">Line</Option>
//           <Option value="pie">Pie</Option>
//         </Select>
//       </div>
//       {loading ? (
//         <div className="flex justify-center">
//           <Spin />
//         </div>
//       ) : (
//         <>
//           {chartType === "column" && (
//             <DynamicColumnChart
//               data={data}
//               xField={xField}
//               yField={yField}
//             //   title={chartTitle}
//               xAxisTitle={xAxisTitle}
//               yAxisTitle={yAxisTitle}
//             />
//           )}
//           {chartType === "bar" && (
//             <DynamicBarChart
//               data={data}
//               xField={xField}
//               yField={yField}
//             //   title={chartTitle}
//               xAxisTitle={xAxisTitle}
//               yAxisTitle={yAxisTitle}
//             />
//           )}
//           {chartType === "line" && (
//             <DynamicLineChart
//               data={data}
//               xField={xField}
//               yField={yField}
//             //   title={chartTitle}
//               xAxisTitle={xAxisTitle}
//               yAxisTitle={yAxisTitle}
//             />
//           )}
//           {chartType === "pie" && (
//             <DynamicPieChart
//               data={data}
//               angleField={yField} // yField as value for pie
//               colorField={xField} // xField as color/group in pie
//             //   title={chartTitle}
//             />
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default AreaCovered;

import React, { useState, useEffect } from "react";
import moment from "moment";
import { Select, Spin } from "antd";
import useHttp from "../../hooks/use-http"; // Use the same hook
import DynamicBarChart from "../barChart";
import DynamicColumnChart from "../columnChart";
import DynamicLineChart from "../lineChart";
import DynamicPieChart from "../pieChart";

const { Option } = Select;

const AreaCovered = ({
  chartTitle = "Area Covered Per Ranch",
  xField = "ranchName",
  yField = "totalArea",
  xAxisTitle = "Ranch Name",
  yAxisTitle = "Area Covered (Ha)"
}) => {
  const [chartType, setChartType] = useState("pie");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const { sendRequest: getData } = useHttp();

  useEffect(() => {
    const url = `/api/ranchPerAreaSummary/?orgId=${localStorage.getItem("orgId")}&userId=${localStorage.getItem("id")}&tdate=${moment().format("DD/MM/YYYY")}`;
    getData(
      { url },
      (res) => {
        setData(res.ranchAreaDistribution || []);
        setLoading(false);
      }
    );
  }, [getData]);

  const handleChartChange = (value) => setChartType(value);

  return (
    <div className="bg-white rounded-2xl shadow-md">
      <div className="flex justify-between items-center mb-4">
        {/* <h4 className="text-lg font-semibold">{chartTitle}</h4> */}
        <Select value={chartType} style={{ width: 120 }} onChange={handleChartChange}>
          <Option value="column">Column</Option>
          <Option value="bar">Bar</Option>
          <Option value="line">Line</Option>
          <Option value="pie">Pie</Option>
        </Select>
      </div>

      {loading ? (
        <div className="flex justify-center"><Spin /></div>
      ) : (
        <>
          {chartType === "column" && (
            <DynamicColumnChart
              data={data}
              xField={xField}
              yField={yField}
              xAxisTitle={xAxisTitle}
              yAxisTitle={yAxisTitle}
            />
          )}
          {chartType === "bar" && (
            <DynamicBarChart
              data={data}
              xField={xField}
              yField={yField}
              xAxisTitle={xAxisTitle}
              yAxisTitle={yAxisTitle}
            />
          )}
          {chartType === "line" && (
            <DynamicLineChart
              data={data}
              xField={xField}
              yField={yField}
              xAxisTitle={xAxisTitle}
              yAxisTitle={yAxisTitle}
            />
          )}
          {chartType === "pie" && (
            <DynamicPieChart
              data={data}
              angleField={yField}
              colorField={xField}
            />
          )}
        </>
      )}
    </div>
  );
};

export default AreaCovered;
